// Import FilePond styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import "./FileUploader.css";

import { FilePond, registerPlugin } from "react-filepond";

import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
// Import the plugin code
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
// Import React FilePond
import React from "react";
import RestUploadMimetypeService from "../../services/RestUploadMimetypeService";

// Register the plugins
registerPlugin(FilePondPluginFileValidateType);
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview, FilePondPluginFileValidateSize);
registerPlugin(FilePondPluginFileValidateSize);

// Component loads up the files
export default class FileUploader extends React.Component {
  fileSizeErrorMessage = "Die Datei ist zu groß";

  constructor(props) {
    super(props);

    this.state = {
      // Set initial files, type 'local' means this is a file
      // that has already been uploaded to the server (see docs)
      files: [],
      errorMessage: undefined
    };
  }

  handleInit() {
    var service = RestUploadMimetypeService();
    service.then((res) => {
      res = res.split(",");
      this.setState({
        mimeType: res
      });
    });
    var element = document.querySelector(".filepond--drop-label");
    element.innerHTML = element.innerHTML
      .replace(/Drop your files or/g, "Datei zum Hochladen")
      .replace(/Browse/g, "auswählen")
      .replace(/Drag &amp;/g, "");
  }

  componentDidMount() {}

  render() {
    return (
      <div
        className="file-uploader"
        style={{ maxwidth: "300px", wordWrap: "breakWord", textAlign: "left", fontFamily: "Lato" }}
      >
        <div
          className="tooltipbase"
          style={{
            fontSize: "16px",
            display: "inline",
            color: "#1c1c1c",
            borderColor: "#132a3e"
          }}
        >
          {" "}
          <span className="tooltiptext">
            Sie haben die Möglichkeit Ihrer Nachricht ein Bild mit der Fehlersituation oder Fehlermeldung hinzuzufügen.
            Machen Sie dazu ein Bildschirmfoto (Screenshot), in welchem die Fehlersituation oder die Fehlermeldung zu
            erkennen ist. Speichern Sie das Bildschirmfoto im JPG-Format ab und fügen Sie es dieser Nachricht an.
          </span>
          <span
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "left",
              fontFamily: "Lato",
              fontWeight: 700,
              marginBottom: "0.5rem",
              display: "inline-block"
            }}
          >
            Bitte hier ein Bild der Fehlersituation hochladen (falls vorhanden)
          </span>
          <div style={{ textAlign: "right", float: "right" }} className="sp-icon-info"></div>
        </div>

        {/* Pass FilePond properties as attributes */}
        <div style={{ border: "3px dashed #b0b0b0" }}>
          <FilePond
            ref={(ref) => (this.pond = ref)}
            files={this.state.files}
            allowMultiple={true}
            acceptedFileTypes={this.state.mimeType}
            maxFiles={6}
            maxFileSize="3MB"
            labelMaxFileSizeExceeded={this.fileSizeErrorMessage}
            labelMaxFileSize="Die Datei darf nicht größer als {filesize} sein"
            method="POST"
            server={{
              process: {
                url: "/api/doUpload",
                onerror: (response) => {
                  let errorMessage;

                  if (response === "MaxUploadSizeExceeded") {
                    errorMessage = this.fileSizeErrorMessage;
                  } else {
                    errorMessage = "Die Datei konnte leider nicht hochgeladen werden";
                  }

                  this.setState({
                    errorMessage: errorMessage
                  });
                }
              }
            }}
            labelFileProcessingError={this.state.errorMessage}
            labelTapToRetry="Klicken Sie hier um es erneut zu versuchen"
            oninit={() => this.handleInit()}
            onupdatefiles={(fileItems) => {
              // Set currently active file objects to this.state
              this.setState({
                files: fileItems.map((fileItem) => fileItem.file)
              });
            }}
          />
        </div>
        <div style={{ margin: "30px" }} />
      </div>
    );
  }
}
